import { render } from "./LigipaasetavusKrhpPaigutusLeht.vue?vue&type=template&id=7c4ef81f&ts=true"
import script from "./LigipaasetavusKrhpPaigutusLeht.vue?vue&type=script&lang=ts"
export * from "./LigipaasetavusKrhpPaigutusLeht.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__